<template>
    <div>
        <el-descriptions title="用户反馈详情" :column="1">
            <el-descriptions-item label="反馈用户名称">{{ detail.nickname }}</el-descriptions-item>
            <el-descriptions-item label="反馈用户ID">{{ detail.wdId }}</el-descriptions-item>
            <el-descriptions-item label="手机号码">{{ detail.phone }}</el-descriptions-item>
            <el-descriptions-item label="反馈时间">{{ detail.feedbackTime }}</el-descriptions-item>
            <el-descriptions-item label="反馈内容">{{ detail.feedbackContent }}</el-descriptions-item>
            <el-descriptions-item label="反馈图片">
                <el-image style="height: 100px;margin-right: 10px;" v-for="(item, index) in images" :src="item"
                    :key="index" :preview-src-list="images"></el-image>
            </el-descriptions-item>
        </el-descriptions>
        <el-button style="margin-left: 70px" size="mini" type="primary" @click="$router.back()">返回</el-button>
    </div>
</template>

<script>
import { feedbackDetail } from "@/api/user/list";
export default {
    data() {
        return {
            detail: {},
            images: []
        }
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        getDetail() {
            feedbackDetail({ id: this.$route.query.id }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.detail = result || {};
                    this.images = result.feedbackImages ? result.feedbackImages.split(',') || [] : [];
                } else {
                    this.$message.error(message);
                }
            });
        }
    }
}
</script>

<style></style>